var _path, _g, _path2, _path3, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoteForDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.109 0H4.242C2.114 0 .875 1.246.875 3.381v7.231C.875 12.782 2.114 14 4.242 14h5.867c2.162 0 3.366-1.218 3.366-3.388V3.381C13.475 1.246 12.271 0 10.109 0",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a873)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b873)",
    d: "M0 0h14v14H0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.431 3.255v.007a.546.546 0 0 0 0 1.092h2.093a.549.549 0 0 0 0-1.099H4.43zM9.92 7.518H4.431a.546.546 0 0 1 0-1.093H9.92a.547.547 0 0 1 0 1.093zm0 3.199H4.431a.544.544 0 0 1-.525-.252.556.556 0 0 1 .525-.847H9.92a.55.55 0 0 1 .49.553c0 .28-.21.518-.49.546z",
    fill: "url(#c873)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 8,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.431 3.255v.007a.546.546 0 0 0 0 1.092h2.093a.549.549 0 0 0 0-1.099H4.43zM9.92 7.518H4.431a.546.546 0 0 1 0-1.093H9.92a.547.547 0 0 1 0 1.093zm0 3.199H4.431a.544.544 0 0 1-.525-.252.556.556 0 0 1 .525-.847H9.92a.55.55 0 0 1 .49.553c0 .28-.21.518-.49.546z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d873)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e873)",
    d: "M.267 0h13.125v14H.267z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b873",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c873",
    x1: 3.822,
    y1: 3.255,
    x2: 3.822,
    y2: 10.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CC1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e873",
    x1: 0.267,
    y1: 0,
    x2: 0.267,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoteForDriver);
export default __webpack_public_path__ + "static/media/ic-note-for-driver.5d0954f3.svg";
export { ForwardRef as ReactComponent };